
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.933 3.133C15.867 3.067 15.8 3 15.667 3H3l-.333-1.733c0-.134-.2-.267-.334-.267h-2C.133 1 0 1.133 0 1.333s.133.334.333.334h1.734l1.6 8.133c.2 1.067 1.2 1.867 2.266 1.867H13.6c.2 0 .333-.134.333-.334S13.8 11 13.6 11H6c-.533 0-1.067-.267-1.333-.733L14.4 8.933a.287.287 0 00.267-.266L16 3.333s0-.133-.067-.2zm-1.866 5.2L4.333 9.6l-1.2-6H15.2l-1.133 4.733zM5.667 12.334A1.65 1.65 0 004 14a1.65 1.65 0 001.667 1.667A1.65 1.65 0 007.333 14a1.65 1.65 0 00-1.666-1.666zm0 2.666c-.534 0-1-.466-1-1 0-.533.466-1 1-1 .533 0 1 .467 1 1 0 .534-.467 1-1 1zM12.333 12.334A1.65 1.65 0 0010.666 14a1.65 1.65 0 001.667 1.667A1.65 1.65 0 0013.999 14a1.65 1.65 0 00-1.666-1.666zm0 2.666c-.534 0-1-.466-1-1 0-.533.466-1 1-1 .533 0 1 .467 1 1 0 .534-.467 1-1 1z","fill":"#6C6C6C"}})])
          )
        }
      }
    